
import { css } from 'lit';
export default css`
pc-admin-links{
  display:block;
  background-color:whitesmoke;
}

  pc-admin-links ul{
    display:flex;
    list-style-type:none;
    margin:0;
    padding:0;
    overflow-x:auto;
  }

  pc-admin-links li{
    margin:0;
    padding:0;
    display:block;
  }

  pc-admin-links a{
    display:inline-block;
    position:relative;
    text-decoration:none;
    padding-top:1rem;
    padding-bottom:1rem;
    padding-left:1.5rem;
    padding-right:1.5rem;
    background:var(--outline-gray-100);
    color:var(--outline-gray-600);
  }

  pc-admin-links a:hover{
      outline:none;
      background:var(--outline-gray-300);
      color:var(--outline-soft-black);
    }

  pc-admin-links a:focus{
      outline:none;
      background:var(--outline-gray-300);
      color:var(--outline-soft-black);
    }

  pc-admin-links a:not(.is-active):hover::before,
    pc-admin-links a:not(.is-active):focus::before{
      position:absolute;
      top:50%;
      left:50%;
      width:calc(100%);
      height:100%;
      content:'';
      transform:translate(-50%, -50%);
      border:solid 2px var(--outline-soft-black);
      border-radius:0.25rem;
    }

  pc-admin-links a.is-active{
      outline:solid 2px var(--outline-soft-black);
      background:var(--purple-indigo);
      color:var(--outline-white);
      z-index:1;
      font-weight:700;
    }

  pc-admin-links a.is-active:hover,
      pc-admin-links a.is-active:focus{
        outline-offset:2px;
      }
`;